import React from "react";
import ReactQuill from "react-quill"; 
import "react-quill/dist/quill.snow.css"; // Quill এর স্টাইল ইম্পোর্ট
import { config } from "../../../../../config";

const imageUrl = config.imageUrl;

const UpdateBonus = ({ 
  formData, 
  handleChange, 
  handleSubmit, 
  handleQuillChange,
  loading, 
  onCancel,
  error 
}) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Bonus</h2>

      {/* Display Loading State */}
      {loading && <p className="text-blue-500 mb-4">Updating...</p>}

      {/* Display Error Message */}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter slug"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter headline"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Offer</label>
          <ReactQuill
            value={formData.offer || ""} // Ensure Quill gets a valid string
            onChange={handleQuillChange}
            className="border w-full p-2"
          />
        </div>

         <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
                type="submit"
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Bonus"}
            </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateBonus;